import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Button, Grid, Typography } from "@mui/material";

import { useAxios } from "../../hooks";
import pages from "../../constants/pages";
import LOGO from "../../assets/image_email.png";
import { alert } from "../../redux/slices/alertSlice";

export default function Form({ code }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const axios = useAxios({ disableAuthToken: true });
  const uiDetails = useSelector((state) => state.renderUIDetails);

  return (
    <div className="wrapper-verify">
      <div className="outer-verify-div">
        <div className="line-box">
          <div className="green-line"></div>
          <div className="purple-line"></div>
          <div className="yellow-line"></div>
        </div>

        <Grid container spacing={3} padding={"0 10px 0"} display={"block"}>
          <Grid
            style={{ paddingTop: "0px" }}
            item
            container
            xs={12}
            justifyContent={"center"}
          >
            <img
              src={uiDetails.siteLogo}
              className="image-verify-logo"
              alt="logo"
            />
          </Grid>

          <Grid
            item
            container
            xs={12}
            textAlign={"start"}
            margin={"25px 0 40px 0"}
          >
            <div className="image-text-div">
              <div
                className="image-business"
                style={{
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <img src={LOGO} className="business-image" alt="!" />
              </div>

              <Typography className="business-heading" textAlign={"center"}>
                <Typography className="congrat-text">
                  {" "}
                  You are almost there! Welcome to the Smart Digital Advertising{" "}
                </Typography>

                <Typography className="congrat-text-2">
                  Please click the button below to verify your email account and
                  proceed to the next steps. We’re excited to have you with us!
                </Typography>
                <Button
                  onClick={handleVerify}
                  variant="contained"
                  className="verify-btn"
                >
                  CLICK TO VERIFY
                </Button>
              </Typography>
            </div>
          </Grid>

          {/* <Grid item xs={12} display={"flex"} justifyContent={"end"}>
            <Copyright /> <Typography>Verismart</Typography>
          </Grid> */}
        </Grid>
      </div>
    </div>
  );

  function handleVerify() {
    axios({
      url: "/user/verifyEmail",
      method: "POST",
      data: {
        code: code,
      },
    }).then((res) => {
      if (res.status) {
        dispatch(
          alert({
            type: "success",
            message: res.message.displayMessage,
          })
        );
        navigate(pages.signIn.route);
      }
    });
  }
}
